
export const ActionType = {
    SetStyle: "SET_STYLE",
    SetLayers: "SET_LAYERS",
    AddLayer: "ADD_LAYER",
    ToggleLayer: "TOGGLE_LAYER",
    SetCenter: "SET_CENTER",
}

export const LOCAL_STORAGE_KEY = "_map_state"

const MapDataReducer = (state, action) => {

    switch(action.type) {
        case ActionType.SetStyle:
            state = {...state, style: action.value}
            break
        case ActionType.SetLayers:
            state = {...state, layers: action.value}
            break
        case ActionType.AddLayer:
            state = {...state, layers: state.layers.includes(action.value) ? state.layers : [...state.layers, action.value]}
            break
        case ActionType.ToggleLayer:
            state = {
                ...state,
                layers: state.layers.includes(action.value) ? [...state.layers.filter(v => v !== action.value)] : [...state.layers, action.value]
            }
            break
        case ActionType.SetCenter:
            state = {...state, center: action.value}
            break
        default:
            return state
    }

    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify({
        ...state,
        // 保存しないデータを以下に追加
        // noSaveData: null,
    }))

    return state
}

export default MapDataReducer
